export default __webpack_public_path__ + "static/media/wrzos.23106a55.svg";